import { render } from "./PGoogleRemove.vue?vue&type=template&id=8e0f2602"
import script from "./PGoogleRemove.vue?vue&type=script&lang=js"
export * from "./PGoogleRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__